import { render, staticRenderFns } from "./recipient_information.vue?vue&type=template&id=2a791a40"
import script from "./recipient_information.vue?vue&type=script&lang=js"
export * from "./recipient_information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "recipient_information.vue"
export default component.exports